import React, { useEffect, useState } from "react";

import { color } from "minimum-ui/tokens";
import styled from "styled-components";
import { Spinner } from "ui/core";

const PageLoader: React.FC = () => {
  // Only show loader when we really need to
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);
  return (
    <PageLoaderWrapper>{showLoader && <Spinner size={60} />}</PageLoaderWrapper>
  );
};

const PageLoaderWrapper = styled.div`
  display: grid;
  min-height: 100vh;
  place-content: center;
  background-color: ${color.background.default};
`;

export default PageLoader;
